var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import clsx from "clsx";
import { createUseStyles, useTheme } from "react-jss";
//Add <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700&display=swap" /> to your html page
/*
xs, extra small: 0 - 575
sm, small: 576 - 767
md, medium: 768 - 991
lg, large: 992 - 1366
xl, extra large: 1367+
 */
export var TextVariant;
(function (TextVariant) {
    TextVariant[TextVariant["welcome"] = 0] = "welcome";
    TextVariant[TextVariant["title"] = 1] = "title";
    TextVariant[TextVariant["subtitle"] = 2] = "subtitle";
    TextVariant[TextVariant["smallButton"] = 3] = "smallButton";
    TextVariant[TextVariant["largeButton"] = 4] = "largeButton";
    TextVariant[TextVariant["s60med"] = 5] = "s60med";
    TextVariant[TextVariant["s48reg"] = 6] = "s48reg";
    TextVariant[TextVariant["s44reg"] = 7] = "s44reg";
    TextVariant[TextVariant["s40black"] = 8] = "s40black";
    TextVariant[TextVariant["s34reg"] = 9] = "s34reg";
    TextVariant[TextVariant["s28reg"] = 10] = "s28reg";
    TextVariant[TextVariant["s24reg"] = 11] = "s24reg";
    TextVariant[TextVariant["s22reg"] = 12] = "s22reg";
    TextVariant[TextVariant["s20med"] = 13] = "s20med";
    TextVariant[TextVariant["s20reg"] = 14] = "s20reg";
    TextVariant[TextVariant["s18med"] = 15] = "s18med";
    TextVariant[TextVariant["s18reg"] = 16] = "s18reg";
    TextVariant[TextVariant["s16reg"] = 17] = "s16reg";
    TextVariant[TextVariant["s14med"] = 18] = "s14med";
    TextVariant[TextVariant["s14thin"] = 19] = "s14thin";
    TextVariant[TextVariant["s12med"] = 20] = "s12med";
    TextVariant[TextVariant["s12reg"] = 21] = "s12reg";
    TextVariant[TextVariant["s10med"] = 22] = "s10med";
    TextVariant[TextVariant["s7med"] = 23] = "s7med";
})(TextVariant || (TextVariant = {}));
var DisplayText = function (props) {
    var theme = useTheme();
    var children = props.children, variant = props.variant, color = props.color, className = props.className, align = props.align, component = props.component, lineHeight = props.lineHeight, fontWeight = props.fontWeight, limitScaling = props.limitScaling, other = __rest(props, ["children", "variant", "color", "className", "align", "component", "lineHeight", "fontWeight", "limitScaling"]);
    var baseColor = color !== null && color !== void 0 ? color : "inherit";
    if (theme.color.hasOwnProperty(baseColor)) {
        // @ts-ignore
        baseColor = theme.color[baseColor].main;
    }
    var classes = useStyles({ color: baseColor, align: align, lineHeight: lineHeight, limitScaling: limitScaling });
    var Component = component !== null && component !== void 0 ? component : "div";
    if (variant === TextVariant.title) {
        Component = "h1";
    }
    else if (variant === TextVariant.subtitle || variant === TextVariant.welcome) {
        Component = "h2";
    }
    return (React.createElement(Component, __assign({ style: { fontWeight: fontWeight } }, other, { className: clsx(className, classes.displayTextBase, classes[TextVariant[variant]]) }), children));
};
export default React.memo(DisplayText);
var useStyles = createUseStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    return ({
        displayTextBase: {
            fontFamily: '"Anova", "Roboto", "Helvetica", "Arial", "sans-serif"',
            letterSpacing: 0,
            margin: 0,
            lineHeight: function (props) { var _a; return (_a = props.lineHeight) !== null && _a !== void 0 ? _a : 1; },
            color: function (props) { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : "inherit"; },
            textAlign: function (props) { var _a; return (_a = props.align) !== null && _a !== void 0 ? _a : "inherit"; },
        },
        welcome: (_a = {
                color: theme.welcome.welcomeText.color,
                fontFamily: "SignPainter",
                fontWeight: 400,
                fontSize: 80
            },
            _a[theme.breakpoints.between("sm", "md")] = {
                fontSize: 70,
            },
            _a[theme.breakpoints.down("xs")] = {
                fontSize: 50,
            },
            _a[theme.breakpoints.up("xxl")] = {
                fontSize: "7vh",
            },
            _a),
        title: (_b = {
                fontFamily: "Anova",
                fontWeight: 700,
                fontSize: 100,
                textTransform: "uppercase"
            },
            _b[theme.breakpoints.between("sm", "md")] = {
                fontSize: 70,
            },
            _b[theme.breakpoints.down("xs")] = {
                fontSize: 40,
            },
            _b[theme.breakpoints.up("xxl")] = {
                fontSize: "9vh",
            },
            _b),
        subtitle: (_c = {
                fontWeight: 400,
                fontSize: 34
            },
            _c[theme.breakpoints.between("sm", "md")] = {
                fontSize: 28,
            },
            _c[theme.breakpoints.down("xs")] = {
                fontSize: 20,
            },
            _c[theme.breakpoints.up("xxl")] = {
                fontSize: "3vh",
            },
            _c),
        smallButton: (_d = {
                fontSize: 20
            },
            _d[theme.breakpoints.down("xs")] = {
                fontSize: 12,
            },
            _d[theme.breakpoints.up("xxl")] = {
                fontSize: "1vw",
            },
            _d),
        largeButton: (_e = {
                fontWeight: 400,
                fontSize: 30
            },
            _e[theme.breakpoints.down("xs")] = {
                fontSize: 18,
            },
            _e[theme.breakpoints.up("xxl")] = {
                fontSize: "1.5vw",
            },
            _e),
        s60med: (_f = {
                fontWeight: 400,
                fontSize: 60
            },
            _f[theme.breakpoints.between("sm", "md")] = {
                fontSize: 48,
            },
            _f[theme.breakpoints.down("xs")] = {
                fontSize: 36,
            },
            _f[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 60 : "3vw"; }
            },
            _f),
        s48reg: (_g = {
                fontWeight: 400,
                fontSize: 48
            },
            _g[theme.breakpoints.down("md")] = {
                fontSize: 44,
            },
            _g[theme.breakpoints.down("xs")] = {
                fontSize: 40,
            },
            _g[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 48 : "2.4vw"; }
            },
            _g),
        s44reg: (_h = {
                fontWeight: 400,
                fontSize: 44
            },
            _h[theme.breakpoints.down("md")] = {
                fontSize: 40,
            },
            _h[theme.breakpoints.down("xs")] = {
                fontSize: 38,
            },
            _h[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 44 : "4vh"; }
            },
            _h),
        s40black: (_j = {
                fontWeight: 700,
                fontSize: 40
            },
            _j[theme.breakpoints.between("sm", "md")] = {
                fontSize: 32,
            },
            _j[theme.breakpoints.down("xs")] = {
                fontSize: 24,
            },
            _j[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 40 : "3.5vh"; },
            },
            _j),
        s34reg: (_k = {
                fontWeight: 400,
                fontSize: 34
            },
            _k[theme.breakpoints.between("sm", "md")] = {
                fontSize: 28,
            },
            _k[theme.breakpoints.down("xs")] = {
                fontSize: 20,
            },
            _k[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 34 : "3vh"; }
            },
            _k),
        s28reg: (_l = {
                fontWeight: 400,
                fontSize: 28
            },
            _l[theme.breakpoints.between("sm", "lg")] = {
                fontSize: 24,
            },
            _l[theme.breakpoints.down("xs")] = {
                fontSize: 18,
            },
            _l[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 28 : "2.5vh"; },
            },
            _l),
        s24reg: (_m = {
                fontWeight: 400,
                fontSize: 24
            },
            _m[theme.breakpoints.between("sm", "md")] = {
                fontSize: 22,
            },
            _m[theme.breakpoints.down("xs")] = {
                fontSize: 16,
            },
            _m[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 24 : "1.2vw"; }
            },
            _m),
        s22reg: (_o = {
                fontWeight: 400,
                fontSize: 22
            },
            _o[theme.breakpoints.between("sm", "md")] = {
                fontSize: 20,
            },
            _o[theme.breakpoints.down("xs")] = {
                fontSize: 16,
            },
            _o[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 22 : "1.1vw"; }
            },
            _o),
        s20med: (_p = {
                fontWeight: 400,
                fontSize: 20
            },
            _p[theme.breakpoints.down("xs")] = {
                fontSize: 14,
            },
            _p[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 20 : "1vw"; }
            },
            _p),
        s20reg: (_q = {
                fontWeight: 400,
                fontSize: 20
            },
            _q[theme.breakpoints.between("sm", "md")] = {
                fontSize: 16,
            },
            _q[theme.breakpoints.down("xs")] = {
                fontSize: 12,
            },
            _q[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 20 : "1vw"; }
            },
            _q),
        s18med: (_r = {
                fontWeight: 400,
                fontSize: 18
            },
            _r[theme.breakpoints.down("xs")] = {
                fontSize: 14,
            },
            _r[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 18 : "1vw"; }
            },
            _r),
        s18reg: (_s = {
                fontWeight: 400,
                fontSize: 18
            },
            _s[theme.breakpoints.down("xs")] = {
                fontSize: 14,
            },
            _s[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 18 : "1vw"; }
            },
            _s),
        s16reg: (_t = {
                fontWeight: 400,
                fontSize: 16
            },
            _t[theme.breakpoints.down("xs")] = {
                fontSize: 12,
            },
            _t[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 16 : "1vw"; }
            },
            _t),
        s14med: (_u = {
                fontWeight: 400,
                fontSize: 14
            },
            _u[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 14 : ".7vw"; }
            },
            _u),
        s14thin: (_v = {
                fontWeight: 100,
                fontSize: 14
            },
            _v[theme.breakpoints.down("xs")] = {
                fontSize: 12,
            },
            _v[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 14 : ".7vw"; }
            },
            _v),
        s12med: (_w = {
                fontWeight: 400,
                fontSize: 12
            },
            _w[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 12 : ".6vw"; }
            },
            _w),
        s12reg: (_x = {
                fontWeight: 400,
                fontSize: 12
            },
            _x[theme.breakpoints.down("xs")] = {
                fontSize: 10,
            },
            _x[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 12 : ".7vw"; }
            },
            _x),
        s10med: (_y = {
                fontWeight: 400,
                fontSize: 10
            },
            _y[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 10 : ".5vw"; }
            },
            _y),
        s7med: (_z = {
                fontWeight: 400,
                fontSize: 7
            },
            _z[theme.breakpoints.up("xxl")] = {
                fontSize: function (props) { return props.limitScaling ? 7 : ".4vw"; }
            },
            _z)
    });
});
//# sourceMappingURL=DisplayText.js.map